import axios from '@/axios.js'

export default {
  getChatMessage ({ commit },idperson) {
    return new Promise((resolve, reject) => {
      axios.get('/person/chat/' + idperson)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPeopleBroker ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/broker/people/data/'+localStorage.getItem('login-broker'))
        .then((response) => {
          commit('SET_PEOPLE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPersonBroker ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/broker/people/data/${localStorage.getItem('login-broker')}/${userId}`)
        .then((response) => {
          commit('SET_PERSON', response.data)
          resolve(response)
          
        })
        .catch((error) => { reject(error) })
    }) 
  },
  fetchPeople ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/people/data')
        .then((response) => {
          commit('SET_PEOPLE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPerson ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/people/data/${userId}`)
        .then((response) => {
          commit('SET_PERSON', response.data)
          resolve(response)
          
        })
        .catch((error) => { reject(error) })
    }) 
  },
  updatePerson ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/person/update', item)
        .then((response) => {
          //commit('UPDATE_USERS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  createPerson ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/person/create', item)
        .then((response) => {
          
          if (localStorage.getItem('creating-operation-and-need-to-add-user')) localStorage.setItem('creating-operation-and-need-to-add-user-person',response.data.id)

          commit('CREATE_PERSON', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createPersonBroker ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/broker/person/'+localStorage.getItem('login-broker')+'/create', item)
        .then((response) => {
          if (localStorage.getItem('creating-operation-and-need-to-add-user')) localStorage.setItem('creating-operation-and-need-to-add-user-person',response.data.id)
          commit('CREATE_PERSON', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAddresses ({ commit },idperson) {
    return new Promise((resolve, reject) => {
      axios.get(`/people_addresses/`+idperson)
        .then((response) => {
          commit('SET_ADDRESSES', response.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    }) 
  }, 
  // « Modifier » postait sur /address/create : l'ancienne adresse etait deliee
  // du contact et une NOUVELLE ligne creee, avec un nouvel identifiant. Les
  // devis et factures continuaient de pointer sur l'ancienne, donc affichaient
  // l'adresse d'AVANT correction. /address/edit met la ligne a jour (ou copie
  // et repointe les documents non figes) et renvoie { mode, repointed, address }.
  updateAddress ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/address/edit', item)
        .then((response) => {
          resolve(response)
          commit('UPDATE_ADDRESS', (response.data && response.data.address) || response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  createAddress ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/address/create', item)
        .then((response) => {
          resolve(response)
          commit('CREATE_ADDRESS', response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAddress ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get("/people/address/delete/" + obj.idperson + "/" + obj.idaddress)
        .then((response) => {
          commit('REMOVE_ADDRESS', obj.idaddress)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
